<template>
  <div>
    <div>
      <t-hero
        :experiment="true"
        :landing-pages="false"
        :background-url="testImage"
        :core="false"
      >
        <div class="flex flex-col lg:items-center lg:flex-row justify-between gap-10 lg:gap-20">
          <div class="lg:w-7/12">
            <h1 class="text-3xl md:text-6xl md:mb-4 text-white text-center leading-tight lg:text-left ">
              Better CE Courses for PTs, OTs and SLPs
            </h1>
            <p class="text-lg md:text-xl text-accent-light  font-bold mt-1 text-center lg:text-left">
              More Courses & Better Quality to Improve Patient Outcomes
            </p>
            <p class="mt-10 text-white text-xs lg:text-sm text-center md:text-left lg:mr-16  font-bold">
              &emsp;
              <t-icon
                class="text-sm text-text-primary -ml-5"
                name="quote-left"
              />
              Summit teachers are amazing and they offer a wide range of topics with live and online experiences. All this for a great price and a wide range of courses. <span class="not-italic"><t-icon
                class="text-sm text-text-primary mr-2"
                name="quote-right"
              />  - Beth, Physical Therapist</span>
            </p>
            <div      class="md:flex mx-auto md:mr-auto">
              <t-button
                variant="ctaPrimary"
                class="mt-10"
                @click.prevent="$router.push('/subscription/subscription-v2')">
                View Subscriptions <t-icon
                  name="chevron-right"
                  class="text-white" />
              </t-button>
            </div>
          </div>
          <div class="hidden lg:flex lg:flex-col lg:items-end lg:w-5/12">
            <div class="hidden md:grid md:grid-rows-2 md:grid-cols-2 md:gap-5">
              <div class="relative text-center rounded p-4">
                <div class="absolute inset-0 bg-black opacity-50 rounded" />
                <img
                  src="//summitproedu.imgix.net/redesign-assets/icons/2025/formats.svg"
                  alt="In Person CE"
                  class="h-10 md:h-14 mx-auto relative z-10"
                />
                <h4 class="font-bold text-white relative z-10">
                  {{ metricsStore.courses }}+
                </h4>
                <p class="text-accent-light  font-bold text-xs lg:text-sm relative z-10">
                  CE Courses Annually <br /> Every Learning Format
                </p>
              </div>
              <div class="relative text-center rounded p-4">
                <div class="absolute inset-0 bg-black opacity-50 rounded" />
                <img
                  src="//summitproedu.imgix.net/redesign-assets/icons/2025/in_person.svg"
                  alt="In Person CE"
                  class="h-10 my-1 md:h-12 mx-auto relative z-10"
                />
                <h4 class="font-bold text-white relative z-10">
                  {{ metricsStore.newCoursesPerYear }}+
                </h4>
                <p class="text-accent-light  font-bold text-xs lg:text-sm relative z-10">
                  New Courses Each Year <br /> + State Requirements
                </p>
              </div>
              <div class="relative text-center rounded p-4">
                <div class="absolute inset-0 bg-black opacity-50 rounded" />
                <img
                  src="//summitproedu.imgix.net/redesign-assets/icons/2025/star_rating.svg"
                  alt="In Person CE"
                  class="h-10 md:h-12 mx-auto relative z-10"
                />
                <h4 class="font-bold text-white relative z-10">
                  {{ metricsStore.stars }}.0
                </h4>
                <p class="text-accent-light  font-bold  text-xs lg:text-sm relative z-10">
                  Star Rating ({{ metricsStore.fiveStarReviews }}k+ <br /> 5-Star Reviews)
                </p>
              </div>
              <div class="relative text-center rounded p-4">
                <div class="absolute inset-0 bg-black opacity-50 rounded" />
                <img
                  src="//summitproedu.imgix.net/redesign-assets/icons/2025/improved_outcomes.svg"
                  alt="In Person CE"
                  class="h-10 md:h-12 mx-auto relative z-10"
                />
                <h4 class="font-bold text-white relative z-10">
                  {{ metricsStore.percentLongFormat }}
                </h4>
                <p class="text-accent-light  font-bold text-xs lg:text-sm relative z-10">
                  of Courses are Long-Format <br /> (2-6 hours)
                </p>
              </div>
            </div>
          </div>
        </div>
      </t-hero>
    </div>
    <div class="bg-gradient-to-r from-primary-140 to-primary-40  py-6">
      <t-container class="flex flex-wrap justify-center items-center">
        <p class=" font-bold text-xl text-accent-light mr-2">
          Stroke Symposium | Nashville
        </p>
        <p class="w-full md:w-auto text-center font-bold text-xl text-white md:mr-6">
          July 17-19, 2025
        </p>
        <t-button
          variant="ctaPrimary"
          class="mt-4 md:ml-2 md:mt-0 lg:ml-0"
          @click.prevent="$router.push('/signature-series/stroke-symposium/nashville-july-2025')">
          Learn More <t-icon
            name="chevron-right"
            class="text-white" />
        </t-button>
      </t-container>
    </div>
    <div class="px-4 md:px-0 py-14 bg-white text-center mx-auto max-w-5xl">
      <h4 class="text-text-primary text-center">
        Find courses by profession
      </h4>
      <div class="flex flex-wrap justify-center gap-4 mt-4">
        <t-button
          id="homepage-pt"
          variant="ctaSecondary"
          @click="$router.push('/courses/profession/physical-therapist')">
          Physical Therapist
        </t-button>
        <t-button
          id="homepage-pta"
          variant="ctaSecondary"
          @click="$router.push('/courses/profession/physical-therapist-assistant')">
          Physical Therapist Assistant
        </t-button>
        <t-button
          id="homepage-ot"
          variant="ctaSecondary"
          @click="$router.push('/courses/profession/occupational-therapist')">
          Occupational Therapist
        </t-button>
        <t-button
          id="homepage-ota"
          variant="ctaSecondary"
          @click="$router.push('/courses/profession/occupational-therapist-assistant')">
          Occupational Therapy Assistant
        </t-button>
        <t-button
          id="homepage-slp"
          variant="ctaSecondary"
          @click="$router.push('/courses/profession/speech-language-pathologist')">
          Speech-Language Pathologist/ Audiologist
        </t-button>
        <t-button
          id="homepage-edu"
          variant="ctaSecondary"
          @click="$router.push('/courses/profession/other-professionals?profession=TEA')">
          Educator
        </t-button>
        <t-button
          id="homepage-atc"
          variant="ctaSecondary"
          @click="$router.push('/courses/profession/other-professionals?profession=ATC')">
          Athletic Trainers
        </t-button>
        <t-button
          id="homepage-ei"
          variant="ctaSecondary"
          @click="$router.push('/courses/profession/other-professionals?profession=EI')">
          Early Intervention
        </t-button>
        <t-button
          id="homepage-other"
          variant="ctaSecondary"
          @click="$router.push('/courses/profession/other-professionals')">
          Other Professionals
        </t-button>
      </div>
    </div>
    <div style="background-color: #f0f0f0;">
      <t-container class="pt-10 pb-2 px-4">
        <h2>Find Your Next Course</h2>
      </t-container>
      <div>
        <t-container class="mx-auto">
          <l-horizontal-scroll-bar
            product-type="VIDEO"
            :cards="courses.VIDEO"
            variant="homepage"
          >
            <template #icon>
              <img
                src="//summitproedu.imgix.net/redesign-assets/icons/2025/online_video.svg"
                alt="On Demand CE"
              />
            </template>
            <template #title>
              Popular On-Demand Video Courses
            </template>
            <template #metric>
              {{ metricsStore.onlineCourses }}+
            </template>
            <template #metricText>
              On-Demand Video/Text Courses
            </template>
          </l-horizontal-scroll-bar>
          <l-horizontal-scroll-bar
            product-type="LIVESTREAM"
            :cards="courses.LIVESTREAM"
            variant="homepage"
          >
            <template #icon>
              <img
                src="//summitproedu.imgix.net/redesign-assets/icons/2025/live-stream.svg"
                alt="Live Stream CE"
              />
            </template>
            <template #title>
              Upcoming Live Stream Courses
            </template>
            <template #metric>
              {{ metricsStore.liveStreams }}+
            </template>
            <template #metricText>
              Live Streams Annually
            </template>
          </l-horizontal-scroll-bar>
        </t-container>
        <div class="my-6 bg-gray-300">
          <t-container class="md:flex md:justify-between p-3">
            <h4 class="text-center font-bold text-xl md:text-2xl">
              Browse courses by topic and patient population
            </h4>
            <nuxt-link
              class="hidden md:block font-bold text-xl text-text-primary mt-1"
              to="/topics"
            >
              See All Topics <t-icon
                name="chevron-right"
                class="text-xl text-text-primary"
              />
            </nuxt-link> <nuxt-link
              to="/topics"
              class="md:hidden mt-4 text-xl block text-text-primary text-center font-bold"
            >
              See All Topics <t-icon
                name="chevron-right"
                class="text-xl text-text-primary"
              />
            </nuxt-link>
          </t-container>
        </div>
        <t-container>
          <l-horizontal-scroll-bar
            product-type="WEBINAR"
            :cards="courses.WEBINAR"
            variant="homepage"
          >
            <template #icon>
              <img
                src="//summitproedu.imgix.net/redesign-assets/icons/2025/webinar.svg"
                alt="Live Webinar CE"
              />
            </template>
            <template #title>
              Upcoming Live Webinars
            </template>
            <template #metric>
              {{ metricsStore.liveWebinars }}+
            </template>
            <template #metricText>
              Live Webinars Annually
            </template>
          </l-horizontal-scroll-bar>
          <l-horizontal-scroll-bar
            product-type="PODCAST"
            :cards="courses.PODCAST"
            variant="homepage"
          >
            <template #icon>
              <img
                src="//summitproedu.imgix.net/redesign-assets/icons/2025/podcast.svg"
                alt="Podcast CE"
              />
            </template>
            <template #title>
              Podcast Episodes
            </template>
            <template #metric>
              Monthly
            </template>
            <template #metricText>
              {{ metricsStore.podcasts }} Episodes
            </template>
          </l-horizontal-scroll-bar>
        </t-container>
        <h6 class="px-4 md:px-0 text-lg text-center mt-14 md:flex items-center justify-center">
          <img
            src="//summitproedu.imgix.net/redesign-assets/icons/2025/in_person.svg"
            alt="Live CE Courses"
            class="h-8 w-8 mx-auto md:mx-0 md:mr-4"
          />
          {{ metricsStore.inPersonCourses }}+ In-Person courses also available.<br class="md:hidden" /> <nuxt-link
            class="text-text-primary font-bold text-lg ml-2 underline"
            to="/courses/format/live"
          >
            See what’s coming near you.
          </nuxt-link>
        </h6>
        <div class="px-4 md:px-0 py-14 mt-14 bg-white text-center mx-auto">
          <h4 class="text-text-primary text-center">
            The Right Course for <br class="md:hidden" /> You is Waiting
          </h4>
          <p class="text-center">
            <span class="text-text-primary font-bold">{{ metricsStore.courses }}+</span> courses to help you meet CE requirements and improve patient outcomes
          </p>
          <t-button
            class="mt-4"
            variant="ctaPrimary"
            @click="$router.push('/courses')"
          >
            See All Courses <t-icon name="chevron-right" />
          </t-button>
        </div>
      </div>
      <div>
        <l-summit-difference />
        <l-image-and-text
          :left="true"
          :img-source="'//summitproedu.imgix.net/redesign-assets/pages/homepage/courses-you-need.jpg'"
        >
          <template #heading>
            The Courses You Need
          </template>
          <template #text>
            Your profession, your setting, your patient population—the right course for you is waiting. With fresh courses weekly, there’s always something new to learn across a wide array of topics.
          </template>
          <div class="py-6">
            <p class="font-bold text-text-primary ml-4">
              <t-icon
                name="check"
                class="text-text-primary mr-4"
              /> {{ metricsStore.courses }}+ Courses
            </p>
            <p class="font-bold text-text-primary ml-4">
              <t-icon
                name="check"
                class="text-text-primary mr-4"
              /> {{ metricsStore.newCoursesPerYear }}+ New Each Year
            </p>
            <p class="font-bold text-text-primary ml-4">
              <t-icon
                name="check"
                class="text-text-primary mr-4"
              /> + State Requirements
            </p>
            <p class="font-bold text-text-primary ml-4">
              <t-icon
                name="check"
                class="text-text-primary mr-4"
              /> Serving All PTs & PTAs, OTs & OTAs, and SLPs
            </p>
          </div>
          <t-button
            variant="ctaPrimary"
            class="mt-4"
            @click="goToSearch()"
          >
            Explore Courses<t-icon
              class="ml-2 mt-1"
              name="chevron-right"
            />
          </t-button>
        </l-image-and-text>
        <l-image-and-text
          :left="false"
          :img-source="'//summitproedu.imgix.net/redesign-assets/pages/homepage/formats-you-want.jpg'"
        >
          <template #heading>
            The Formats You Want
          </template>
          <template #text>
            Attend, stream, watch, listen, or read. Not only do Summit’s six course formats let you choose your preferred learning style, they also allow for individual topics to be presented in the best way for maximizing comprehension and retention.
          </template>
          <div class="py-6">
            <nuxt-link
              to="/courses/format/video"
              class="items-center hover:opacity-80"
            >
              <p class="font-bold text-text-primary lg:ml-4">
                <t-icon
                  name="check"
                  class="text-text-primary mr-4"
                /> {{ metricsStore.onlineCourses }}+ On-Demand Video & Text Courses
              </p>
            </nuxt-link>
            <nuxt-link
              to="/courses/format/webinar"
              class="items-center hover:opacity-80"
            >
              <p class="font-bold text-text-primary lg:ml-4">
                <t-icon
                  name="check"
                  class="text-text-primary mr-4"
                /> {{ metricsStore.liveWebinars }}+ Live Webinars Annually
              </p>
            </nuxt-link>
            <nuxt-link
              to="/courses/format/live-streaming"
              class="items-center hover:opacity-80"
            >
              <p class="font-bold text-text-primary lg:ml-4">
                <t-icon
                  name="check"
                  class="text-text-primary mr-4"
                /> {{ metricsStore.liveStreams }}+ Live Streams Annually
              </p>
            </nuxt-link>
            <nuxt-link
              to="/courses/format/live"
              class="items-center hover:opacity-80"
            >
              <p class="font-bold text-text-primary lg:ml-4">
                <t-icon
                  name="check"
                  class="text-text-primary mr-4"
                /> {{ metricsStore.inPersonPerYear }}+ In-Person Courses Annually
              </p>
            </nuxt-link>
            <nuxt-link
              to="/courses/format/podcast"
              class="items-center hover:opacity-80"
            >
              <p class="font-bold text-text-primary lg:ml-4">
                <t-icon
                  name="check"
                  class="text-text-primary mr-4"
                /> Monthly {{ metricsStore.podcasts }} Episodes
              </p>
            </nuxt-link>
          </div>
          <t-button
            variant="ctaPrimary"
            class="mt-4"
            @click="goToSearch()"
          >
            Explore Courses<t-icon
              class="ml-2 mt-1"
              name="chevron-right"
            />
          </t-button>
        </l-image-and-text>
        <l-summit-difference test-variant="C" />
        <l-image-and-text
          :left="true"
          :img-source="'//summitproedu.imgix.net/redesign-assets/pages/homepage/feedback.jpg'"
        >
          <template #heading>
            Your Feedback Drives Everything
          </template>
          <template #text>
            Therapists like you provide feedback after every course completion. We use this to provide you only the best quality and breadth of content, and you can see these customer ratings and reviews for every course we offer — so you’re confident every course is worth your time.
          </template>
          <div class="py-6">
            <p class="font-bold text-text-primary ml-4">
              <t-icon
                name="check"
                class="text-text-primary mr-4"
              /> {{ metricsStore.stars }} Star Course Rating
            </p>
            <p class="font-bold text-text-primary ml-4">
              <t-icon
                name="check"
                class="text-text-primary mr-4"
              /> {{ metricsStore.fiveStarReviews }},000+ 5 Star Reviews
            </p>
            <p class="font-bold text-text-primary ml-4">
              <t-icon
                name="check"
                class="text-text-primary mr-4"
              /> {{ metricsStore.ceuDelivered }},000,000+ CEUs Delivered
            </p>
            <p class="font-bold text-text-primary ml-4">
              <t-icon
                name="check"
                class="text-text-primary mr-4"
              /> {{ metricsStore.customerServiceSatisfaction }} Customer Service Satisfaction
            </p>
          </div>
          <t-button
            variant="ctaPrimary"
            class="mt-4"
            @click="goToSearch()"
          >
            Explore Courses<t-icon
              class="ml-2 mt-1"
              name="chevron-right"
            />
          </t-button>
        </l-image-and-text>
        <l-image-and-text
          :left="false"
          :img-source="'//summitproedu.imgix.net/redesign-assets/pages/homepage/deepest-learning.jpg'"
        >
          <template #heading>
            The Deepest Learning Experience
          </template>
          <template #text>
            Summit offers courses up to 6 CEUs, meaning that you have the time necessary to fully explore more complex disciplines and gain the practical skills that only come from a deep dive into a topic. Combine this with instructors selected not only for their professional achievements, but also for their engaging presentation style, and you’ve got a CE experience built to maximize comprehension, skill development, retention, and patient outcome improvement.
          </template>
          <div class="py-6">
            <p class="font-bold text-text-primary lg:ml-4">
              <t-icon
                name="check"
                class="text-text-primary mr-4"
              /> {{ metricsStore.instructorRating }} Star Instructor Rating
            </p>
            <p class="font-bold text-text-primary lg:ml-4 ">
              <t-icon
                name="check"
                class="text-text-primary mr-4"
              /> {{ metricsStore.percentLongFormat }} of Courses are Long-Format (2-6 hours)
            </p>
            <p class="font-bold text-text-primary lg:ml-4 span-6 ">
              <t-icon
                name="check"
                class="text-text-primary mr-4"
              /> Dynamic, Multi-Camera Course Production
            </p>
          </div>
          <t-button
            variant="ctaPrimary"
            class="mt-4"
            @click="goToSearch()"
          >
            Explore Courses<t-icon
              class="ml-2 mt-1"
              name="chevron-right"
            />
          </t-button>
        </l-image-and-text>
      </div>
      <l-gradient-section :three-cards="true" />
      <t-container>
        <l-trust-pilot-reviews />
      </t-container>
    </div>
    <t-video-hero
      :footer="true"
      background-url="//d2vu1vyohnm3g3.cloudfront.net/home-video/2021-search-video.mp4"
    >
      <template #title>
        Find the Topic You Want
      </template>
      <div class="flex justify-center">
        <nav-search-nav variant="footer" />
      </div>
      <div class="mt-4">
        <Nuxt-link
          to="/courses"
          class="text-white hover:border-b-2 border-white"
        >
          or <span class="font-bold">Browse All Courses</span>
        </Nuxt-link>
      </div>
    </t-video-hero>
  </div>
</template>

<script>
import { mapState, mapStores, mapActions, } from 'pinia';
import { useMetricStore, } from '../stores/metrics';
import { useSearchStore, } from '../stores/search';
import useFetchCustom from '../composables/useFetchCustom';
import { useHead, } from '#imports';


export default {
  name: 'Home',
  setup(){
    useHead({
      title: 'Live & Online Continuing Education for PTs, OTs and SLPs',
      description: 'National leader of continuing education for therapists. In-person, live streaming, live webinars, online videos, and online text courses offering CEUs for PTs, OTs, and SLPs',
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          content: 'Live & Online Continuing Education for PTs, OTs and SLPs',
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content: 'National leader of continuing education for therapists. In-person, live streaming, live webinars, online videos, and online text courses offering CEUs for PTs, OTs, and SLPs',
        },
        {
          hid: 'description',
          name: 'description',
          content: 'National leader of continuing education for therapists. In-person, live streaming, live webinars, online videos, and online text courses offering CEUs for PTs, OTs, and SLPs',
        },
      ],
    });
  },
  data() {
    return {
      imagePath: 'https://summitproedu.imgix.net/landing-pages/pt-phippf.jpg',
      testImage: 'https://summitproedu.imgix.net/redesign-assets/new-heros/HERO_SNOW_Homepage.jpg',
      bannerText: '',
      discountCode: '',
      discountText: '',
      courses: [],
      videoFilter: {
        searchText: '',
        profession: [],
        state: [],
        format: ['VIDEO'],
        topic: [],
        setting: [],
        credits: [],
        limit: 19,
      },
      livestreamFilter: {
        searchText: '',
        profession: [],
        state: [],
        format: ['LIVESTREAM'],
        topic: [],
        setting: [],
        credits: [],
        limit: 19,
      },
      webinarFilter: {
        searchText: '',
        profession: [],
        state: [],
        format: ['WEBINAR'],
        topic: [],
        setting: [],
        credits: [],
        limit: 19,
      },
      podcastFilter: {
        searchText: '',
        profession: [],
        state: [],
        format: ['PODCAST'],
        topic: [],
        setting: [],
        credits: [],
        limit: 19,
      },
    };
  },
  computed: {
    ...mapStores(useMetricStore),
    ...mapState(useSearchStore, ['page', 'PageType']),
    getSelectedClasses() {
      return pageType => this.page === pageType ? 'border-b-4 border-primary-140' : null;
    },
  },
  async mounted() {
    await this.setPage(this.PageType.COURSES);
    this.courses = await useFetchCustom('GET', '/course/layout');
  },
  methods: {
    ...mapActions(useSearchStore, [
      'setProfession',
      'setFilter',
      'applyFilters',
      'setPage',
    ]),
    goToSearch() {
      this.$router.push('/courses');
    },
    updateFilters(type, selected) {
      this.setFilter(selected);
    },
    goToPage(page) {
      this.$router.push(page);
    },

  },
};
</script>
